import { render } from "./index-choose.vue?vue&type=template&id=3270b675&scoped=true"
import script from "./index-choose.vue?vue&type=script&lang=js"
export * from "./index-choose.vue?vue&type=script&lang=js"

import "./index-choose.vue?vue&type=style&index=0&id=3270b675&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3270b675"]])

export default __exports__